import React, {Component} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {fromSystemDateTime, toHumanDateTime} from '../utils/date';

const tooltip = (
    <Tooltip id="tooltip">
        {window.__js_bid_reviews.reviewer_role_tooltip}
    </Tooltip>
);

const BidsAlwaysEnabledWarning = ({}) => {
    return (
        <div className="text-warning" style={{
            marginLeft: '5px',
            display: 'inline-block',
            fontSize: '25px'
        }}>
            <OverlayTrigger placement="top" overlay={tooltip}>
                <i className="fa fa-fw fa-question-circle"></i>
            </OverlayTrigger>
        </div>
    );
}

const WinnerApprovalStatus = ({status}) => {
    let content = (
        <span className="text-warning">
            <i className="fa fa-fw fa-question"></i>
            {window.__js_bid_reviews.pending}
        </span>
    );

    switch (status) {
        case false:
            content = (
                <span className="text-danger">
                    <i className="fa fa-fw fa-times"></i>
                    {window.__js_bid_reviews.discarded}
                </span>
            );
            break;
        case true:
            content = (
                <span className="text-success">
                    <i className="fa fa-fw fa-check"></i>
                    {window.__js_bid_reviews.approved}
                </span>
            );
            break;
    }

    return (
        <span className="text-bold">
            {content}
        </span>
    );
}

export default class ReviewersTableReadonly extends Component {
    render() {
        const {reviewers, data} = this.props;

        if (reviewers.length === 0) {
            return (
                <p>
                    <em>{window.__js_bid_reviews.no_reviewers_assigned}</em>
                </p>
            );
        }

        return (
            <div className="form-group">
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover">
                        <thead>
                        <tr>
                            <td className="bg-warning text-primary"></td>
                            <td></td>
                            <td colSpan={4} className="bg-primary text-bold text-center">
                                {window.__js_bid_reviews.assignment_evaluation}
                            </td>
                        </tr>
                        <tr>
                            <th rowSpan={2} className="bg-warning text-primary">{window.__js_general.username}</th>
                            <th rowSpan={2}>{window.__js_bid_reviews.review_bids}</th>
                            <th className="bg-primary">{window.__js_general.enable}</th>
                            <th className="bg-primary">{window.__js_general.status}</th>
                            <th className="bg-primary">{window.__js_bid_reviews.rejection_reason}</th>
                            <th className="bg-primary">{window.__js_bid_reviews.review_datetime}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            reviewers.map((item) => {
                                const bidsAlwaysEnabled = (item.bid_review_always_enabled === true);

                                let canAssessBids = false;
                                let canAssessWinner = false;
                                let winnerIsApproved = null;
                                let winnerNotes = '';
                                let winnerReviewedAt = null;

                                if (data.hasOwnProperty(item.value)) {
                                    const element = data[item.value];

                                    canAssessBids = (element.can_assess_bids === true);
                                    canAssessWinner = (element.can_assess_winner === true);
                                    winnerIsApproved = element.winner_is_approved;
                                    winnerNotes = element.winner_notes || '';

                                    winnerReviewedAt = element.winner_reviewed_at;
                                    if (winnerReviewedAt) {
                                        winnerReviewedAt = toHumanDateTime(fromSystemDateTime(winnerReviewedAt));
                                    }
                                }

                                if (bidsAlwaysEnabled) {
                                    canAssessBids = true;
                                }

                                return (
                                    <tr key={item.value}>
                                        <td style={{verticalAlign: 'middle'}}>{item.label}</td>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   checked={canAssessBids}
                                                   disabled={true}/>

                                            {
                                                bidsAlwaysEnabled
                                                    ? <BidsAlwaysEnabledWarning/>
                                                    : null
                                            }
                                        </td>
                                        <td style={{verticalAlign: 'middle'}}>
                                            <input type="checkbox"
                                                   value="1"
                                                   checked={canAssessWinner}
                                                   disabled={true}/>
                                        </td>
                                        <td>
                                            <WinnerApprovalStatus status={winnerIsApproved}/>
                                        </td>
                                        <td>{winnerNotes}</td>
                                        <td>{winnerReviewedAt}</td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
};